import {CircularProgress} from '@mui/material';
import {AgyleLogoIcon} from '../icons/icons';
import React from 'react';

const MainLoadingScreen = () => {
    if (process.env.BUILD_MODULE !== 'agyle') return <span>Loading...</span>;

    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100vh',
            gap: 10,
        }}>
            <AgyleLogoIcon style={{fontSize: 208, marginBottom: 50}}/>
            <span style={{fontSize: 24, marginBottom: 20, fontWeight: 600}}>
                Loading aplication...
            </span>
            <CircularProgress color="primary" size={64}/>
        </div>
    );
};

export default MainLoadingScreen;